<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container">
                    <div class="page-links">
                        <router-link to="/trips/tanzania" class="page-links__item">Tanzania Day Trips</router-link>
                        <router-link to="/trips/safari" class="page-links__item is-active">Safari Activities</router-link>
                        <router-link to="/trips/island" class="page-links__item">Island Activities</router-link>
                    </div>
                    <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                    <section class="day-trips-activities" v-if="isLoad">
                        <div class="page-title">
                            <h2>Safari Activities</h2>
                            <div class="page-title__side">
                            <div class="form-control-wrap">
                                <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                                <div class="form-control-icon">
                                <svg width="1em" height="1em" class="icon icon-search ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                                </svg>
                                </div>
                            </div><router-link to="/trips/safari/add" class="btn btn--green btn--shadowed"> <span>Add Activity</span></router-link>
                            </div>
                        </div>
                        <div data-simplebar="data-simplebar" class="day-trips-activities__table-wrap day-trips-activities__table--safari">
                            <div class="day-trips-activities__table">
                                <div class="day-trips-activities__table__head">
                                    <div class="col col-name"> <span>Name</span></div>
                                    <div class="col col-park"><span>National Park</span></div>
                                    <div class="col col-created"><span>Created</span></div>
                                    <div class="col col-update"><span>Last Update</span></div>
                                </div>
                                <a href="javascript:void(0)" class="day-trips-activities__table__row" v-for="(item, index) in safari.slice((page - 1) * 15, ((page - 1) * 15) + 15)" :key="item.id">
                                    <div class="col col-name"><span>{{item.name}}</span></div>
                                    <div class="col col-park"><span>{{item.parkName}}</span></div>
                                    <div class="col col-created"><span>{{item.createdAt}}</span></div>
                                    <div class="col col-update"><span>{{item.updatedAt}}</span></div>
                                    <div class="col col-action">
                                        <button type="button" class="day-trips-activities__table__dropdown-trigger" @click="openMenu(item.id)">
                                            <svg width="1em" height="1em" class="icon icon-more ">
                                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                                            </svg>
                                            <div :class="['edit-popup edit-popup--short', { 'toup' : index + 1 === safari.slice((page - 1) * 15, ((page - 1) * 15) + 15).length && index + 1 !== 1}]" v-if="item.menu">
                                                <div class="form-control-group">
                                                <button type="button" class="btn form-control-action" @click="$router.push('/trips/safari/' + item.id)"><span
                                                    class="form-control-action__icon icon--green">
                                                    <svg width="1em" height="1em" class="icon icon-edit ">
                                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                                    </svg></span><span class="form-control-action__text">Edit</span></button>
                                                </div>
                                                <div class="form-control-group">
                                                <button type="button" class="btn form-control-action"  @click="$emit('deleteModalHandler', {
                                                    entity: 'Activity',
                                                    name: item.name,
                                                    handler: deleteSafariHandler,
                                                    id: item.id
                                                })"><span
                                                    class="form-control-action__icon icon--red">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg></span><span class="form-control-action__text">Delete</span></button>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <Pagination 
                            :page="page"
                            :pageCount="pageCount" 
                            @pageController="pageController"
                        />
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

    import Pagination from '@/components/Pagination'

    import { 
        getSafariAll,
        deleteSafari
    } from '@/utilites/api'

    export default {
        components: { Pagination },
        data(){
            return {
                search: '',
                safari: [],
                safariData: [],
                page: 1,
                pageCount: 0,
                isLoad: false
            }
        },
        props: ['user'],
        methods: {
            pageController(page){
                this.page = page
            },
            pageCountHandler(){
                this.pageCount = Math.ceil(this.safari.length / 15)
            },
            updateData(){
                this.isLoad = false
                getSafariAll(this.user.access_token)
                .then(res => {
                    this.isLoad = true
                    this.safari = res.map(item => ({...item, menu: false}))
                    this.safariData = res.map(item => ({...item, menu: false}))
                })
			},
            openMenu(id){
                this.safari = this.safari.map(item => item.id === id ? {...item, menu: !item.menu} : {...item, menu: false})
            },
            deleteSafariHandler(id){
                deleteSafari(this.user.access_token, id)
                .then(() => this.updateData())
            }
        },
        beforeCreate(){
           document.title = 'Day Trips & Activities / Safari Activities'
        },
        mounted(){
            document.title = 'Day Trips & Activities / Safari Activities'
            this.updateData()
            window.addEventListener('click', event => {
                if(!event.target.closest('.day-trips-activities__table__dropdown-trigger')){
                    this.safari = this.safari.map(item => ({...item, menu: false}))
                }
            })
        },
        watch: {
            search(){
                if(this.search.length === 0){
                    this.safari = this.safariData
                }
                this.page = 1
                let filtered = this.safariData.filter(item => this.search.length ? ((item.name && item.name.toLowerCase().includes(this.search.toLowerCase())) || (item.parkName && item.parkName.toLowerCase().includes(this.search.toLowerCase()))) ? item : false : item)
                this.safari = filtered
                this.pageCount = Math.ceil(filtered.length / 15)
            }
        }
    }
</script>
